import { forwardRef } from 'react';
import { theme } from '@frontend/theme';
import { Button, ButtonProps } from '@frontend/design-system';

type SettingsBulkActionButtonProps = Omit<ButtonProps, 'variant' | 'size'>;

export const SettingsBulkActionButton = forwardRef<HTMLButtonElement, SettingsBulkActionButtonProps>((props, ref) => {
  return (
    <Button
      ref={ref}
      css={{
        color: theme.font.colors.default,
        fontWeight: theme.font.weight.regular,
        ':hover, :active, :focus': {
          backgroundColor: theme.colors.neutral20,
        },
        padding: theme.spacing(1),
      }}
      size='small'
      {...props}
      variant='tertiary'
    />
  );
});
SettingsBulkActionButton.displayName = 'SettingsBulkActionButton';
